import { FavoritableType } from 'api/clients/FavoriteClient'
import { FavoriteService } from 'api/services/FavoriteService'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation, useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import { FileType } from 'types'

export const useCreateFavorite = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()
  const dispatch = useDispatch()

  interface CreateFavoriteProps {
    favoritableId: string
    favoritableType: FileType
    favoritableTitle: string
  }

  const createFavorite = useMutation(
    async ({ favoritableId, favoritableType }: CreateFavoriteProps) => {
      const favoritableTypeMap = {
        folder: FavoritableType.Project,
        article: FavoritableType.Article,
        handbook: FavoritableType.Handbook,
        media_file: FavoritableType.MediaFile,
        design: FavoritableType.Design,
        video: FavoritableType.Video,
      }
      return await FavoriteService.createFavorite(favoritableId, favoritableTypeMap[favoritableType], dispatch)
    },
    {
      onSuccess: (_, { favoritableTitle }) => {
        queryClient.invalidateQueries(['workspace', currentWorkspaceId, 'files', 'favorites'])
        showToastMessage(
          <span>
            <span role="img" aria-label="celebration horn">
              🎉
            </span>{' '}
            <b>{favoritableTitle}</b> added to your favorites!
          </span>,
          'success',
        )
      },
    },
  )

  return createFavorite
}
